import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './print-summary.module.scss';
import { Spin } from 'antd';
import { pdcMeetingApi } from '../../../../../services/pdcMeetingApi';
import { useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';
import SummaryMeeting from '../../../components/SummaryMeeting/SummaryMeeting';
import PreReadLabel from '../PreReadLabel/PreReadLabel';
import { PRC_MEETING_SUMMARY_TABLES_KEYS } from '../../../constants';

const PrintSummary = ({ idMeeting, preRead }) => {
  const roleActive = useSelector((state) => state.user.roleActive);
  const selectedKeys = useSelector((state) => state.app.pdcMeetingModule.pdcSummaryTableView.selectedKeys);
  const [data, setData] = useState({
    by_proposal_type: [],
    by_effective_date: [],
    loading: true,
  });
  const [selectedKey, setSelectedKey] = useState(selectedKeys);

  useEffect(() => {
    if (!idMeeting) {
      return;
    }

    pdcMeetingApi.getMeetingPdcSummaryTableView(idMeeting).then((res) => {
      const { data } = res;
      setSelectedKey(data.result);
    });
  }, [idMeeting, selectedKeys]);

  useEffect(() => {
    if (!idMeeting || !roleActive.roleId) return;
    (async function getSummaryProposal() {
      try {
        setData((prev) => ({ ...prev, loading: true }));
        const res = await pdcMeetingApi.fetchSummaryProposal(idMeeting, roleActive.roleId);
        setData({
          by_proposal_type: get(res, 'data.result.by_proposal_type') || [],
          by_effective_date: get(res, 'data.result.by_effective_date') || [],
          loading: false,
        });
      } catch (error) {
        console.error(error);
        setData({
          by_proposal_type: [],
          by_effective_date: [],
          loading: false,
        });
      }
    })();
  }, [idMeeting, roleActive.roleId]);
  return (
    <Spin spinning={data.loading}>
      <div className={styles.wrapper}>
        <div className={styles.title}>
          Summary
          {preRead && <PreReadLabel />}
        </div>

        {selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.ALL || selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.PDC_PROPOSAL ? (
          <div>
            {!isEmpty(data.by_proposal_type) && (
              <>
                <div className={styles.subTitle}>Summary of PDC Proposal</div>
                <SummaryMeeting data={data.by_proposal_type} />
              </>
            )}
          </div>
        ) : null}

        {selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.ALL || selectedKey === PRC_MEETING_SUMMARY_TABLES_KEYS.PDC_PROPOSAL_BY_EFFECTIVE_DATE ? (
          <div>
            {!isEmpty(data.by_effective_date) && (
              <>
                <div className={styles.subTitle}>Summary of PDC Proposal By Effective Date</div>
                <SummaryMeeting data={data.by_effective_date} isByDate />
              </>
            )}
          </div>
        ) : null}
      </div>
    </Spin>
  );
};

export default PrintSummary;

PrintSummary.propTypes = {
  idMeeting: PropTypes.string,
  preRead: PropTypes.bool,
};
